import React from 'react';

function BlockJ() {
  const productsData = [
    {
      slNo: 1,
      description: '3-cyano pyridine',
      itemCode: '3416002',
      unit: 'Kg',
      quantityManufactured: '',
      qtySold: '',
      grossSaleValue: '',
      gst: 0,
      exciseDuty: 0,
      distributiveExpenses: 0,
      subsidy: 0,
      perUnitSaleValue: 0,
      exFactoryValue: ''
    },
    {
      slNo: 2,
      description: '',
      itemCode: '',
      unit: '',
      quantityManufactured: '',
      qtySold: '',
      grossSaleValue: '',
      gst: 0,
      exciseDuty: 0,
      distributiveExpenses: 0,
      subsidy: 0,
      perUnitSaleValue: 0,
      exFactoryValue: ''
    },
    {
      slNo: 3,
      description: '',
      itemCode: '',
      unit: '',
      quantityManufactured: '',
      qtySold: '',
      grossSaleValue: '',
      gst: 0,
      exciseDuty: 0,
      distributiveExpenses: 0,
      subsidy: 0,
      perUnitSaleValue: 0,
      exFactoryValue: ''
    },
    {
      slNo: 4,
      description: '',
      itemCode: '',
      unit: '',
      quantityManufactured: '',
      qtySold: '',
      grossSaleValue: '',
      gst: 0,
      exciseDuty: 0,
      distributiveExpenses: 0,
      subsidy: 0,
      perUnitSaleValue: 0,
      exFactoryValue: ''
    },
    {
      slNo: 5,
      description: '',
      itemCode: '',
      unit: '',
      quantityManufactured: '',
      qtySold: '',
      grossSaleValue: '',
      gst: 0,
      exciseDuty: 0,
      distributiveExpenses: 0,
      subsidy: 0,
      perUnitSaleValue: 0,
      exFactoryValue: ''
    },
    {
      slNo: 6,
      description: '',
      itemCode: '',
      unit: '',
      quantityManufactured: '',
      qtySold: '',
      grossSaleValue: '',
      gst: 0,
      exciseDuty: 0,
      distributiveExpenses: 0,
      subsidy: 0,
      perUnitSaleValue: 0,
      exFactoryValue: ''
    },
    {
      slNo: 7,
      description: '',
      itemCode: '',
      unit: '',
      quantityManufactured: '',
      qtySold: '',
      grossSaleValue: '',
      gst: 0,
      exciseDuty: 0,
      distributiveExpenses: 0,
      subsidy: 0,
      perUnitSaleValue: 0,
      exFactoryValue: ''
    },
    {
      slNo: 8,
      description: '',
      itemCode: '',
      unit: '',
      quantityManufactured: '',
      qtySold: '',
      grossSaleValue: '',
      gst: 0,
      exciseDuty: 0,
      distributiveExpenses: 0,
      subsidy: 0,
      perUnitSaleValue: 0,
      exFactoryValue: ''
    },
    {
      slNo: 9,
      description: '',
      itemCode: '',
      unit: '',
      quantityManufactured: '',
      qtySold: '',
      grossSaleValue: '',
      gst: 0,
      exciseDuty: 0,
      distributiveExpenses: 0,
      subsidy: 0,
      perUnitSaleValue: 0,
      exFactoryValue: ''
    },
    {
      slNo: 10,
      description: '',
      itemCode: '',
      unit: '',
      quantityManufactured: '',
      qtySold: '',
      grossSaleValue: '',
      gst: 0,
      exciseDuty: 0,
      distributiveExpenses: 0,
      subsidy: 0,
      perUnitSaleValue: 0,
      exFactoryValue: ''
    },
    {
      slNo: 11,
      description: 'Other products/by-products',
      itemCode: '9921100',
      unit: '',
      quantityManufactured: '',
      qtySold: '',
      grossSaleValue: '',
      gst: 0,
      exciseDuty: 0,
      distributiveExpenses: 0,
      subsidy: 0,
      perUnitSaleValue: 0,
      exFactoryValue: ''
    },
    {
      slNo: 12,
      description: 'Total (1 to 11)',
      itemCode: '9995000',
      unit: 'X',
      quantityManufactured: '',
      qtySold: '',
      grossSaleValue: '',
      gst: 0,
      exciseDuty: 0,
      distributiveExpenses: 0,
      subsidy: 0,
      perUnitSaleValue: 0,
      exFactoryValue: 'X'
    }
  ];

  const formatNumber = (num) => {
    if (num === '' || num === null || num === undefined) return '';
    if (num === 'X') return 'X';
    return num.toLocaleString();
  };

  return (
    <>
      <style>
        {`
          .block-j-header {
            background-color: #e3f2fd;
            padding: 15px 20px;
            border-bottom: 2px solid #1976d2;
            margin-bottom: 20px;
          }
          .page-title {
            color: #1976d2;
            font-size: 24px;
            font-weight: bold;
            margin: 0;
          }
          .reference-numbers {
            color: #333;
            font-size: 14px;
            font-weight: 500;
            margin: 0;
          }
          .products-table {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 20px;
          }
          .table-header {
            background-color: #f8f9fa;
            border-bottom: 2px solid #1976d2;
          }
          .table th {
            background-color: #e3f2fd;
            color: #1976d2;
            font-weight: 600;
            font-size: 10px;
            text-align: center;
            vertical-align: middle;
            padding: 8px 2px;
            border: 1px solid #dee2e6;
          }
          .table td {
            font-size: 10px;
            text-align: center;
            vertical-align: middle;
            padding: 6px 2px;
            border: 1px solid #dee2e6;
          }
          .table td:first-child {
            text-align: center;
            font-weight: 600;
            width: 40px;
          }
          .table td:nth-child(2) {
            text-align: left;
            font-weight: 500;
            min-width: 150px;
          }
          .table td:nth-child(3) {
            text-align: center;
            font-weight: 500;
            width: 80px;
          }
          .table td:nth-child(4) {
            text-align: center;
            font-weight: 500;
            width: 60px;
          }
          .table td:nth-child(5),
          .table td:nth-child(6),
          .table td:nth-child(7),
          .table td:nth-child(8),
          .table td:nth-child(9),
          .table td:nth-child(10),
          .table td:nth-child(11),
          .table td:nth-child(12),
          .table td:nth-child(13) {
            text-align: right;
            font-weight: 500;
            width: 70px;
          }
          .total-row {
            background-color: #f8f9fa;
            font-weight: 600;
          }
          .footer-section {
            background-color: #f8f9fa;
            padding: 15px;
            border: 1px solid #dee2e6;
            border-radius: 6px;
            margin-bottom: 20px;
          }
          .export-share-label {
            font-weight: 600;
            color: #333;
            margin-right: 10px;
          }
          .export-share-input {
            width: 200px;
            padding: 8px;
            border: 1px solid #ddd;
            border-radius: 4px;
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section */}
        <div className="block-j-header">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1 className="page-title">J: PRODUCTS AND BY-PRODUCTS (manufactured by the unit)</h1>
            </div>
            <div className="col-md-6 text-end">
              <p className="reference-numbers">DSL No : 404936</p>
              <p className="reference-numbers">PSL No : 31186</p>
            </div>
          </div>
        </div>

        {/* Products and By-products Table */}
        <div className="products-table">
          <div className="table-responsive">
            <table className="table table-bordered mb-0">
              <thead className="table-header">
                <tr>
                  <th>Sl No</th>
                  <th>Products/By-products descriptions</th>
                  <th>Item code (NPC-MS)</th>
                  <th>Unit of Quantity</th>
                  <th>Quantity Manufactured</th>
                  <th>Qty. Sold</th>
                  <th>Gross Sale Value (Rs.)</th>
                  <th>Good and Services Tax (GST)</th>
                  <th>Excise Duty/Sales Tax etc.,</th>
                  <th>Other Distributive expenses</th>
                  <th>Subsidy</th>
                  <th>Per Unit Sale Value</th>
                  <th>Ex-factory Value of Quantity manufactured(Rs.) (col.12*col. 5)</th>
                </tr>
              </thead>
              <tbody>
                {productsData.map((row, index) => (
                  <tr key={index} className={row.slNo === 12 ? 'total-row' : ''}>
                    <td>{row.slNo}</td>
                    <td>{row.description}</td>
                    <td>{row.itemCode}</td>
                    <td>{row.unit}</td>
                    <td>{row.quantityManufactured}</td>
                    <td>{row.qtySold}</td>
                    <td>{row.grossSaleValue}</td>
                    <td>{formatNumber(row.gst)}</td>
                    <td>{formatNumber(row.exciseDuty)}</td>
                    <td>{formatNumber(row.distributiveExpenses)}</td>
                    <td>{formatNumber(row.subsidy)}</td>
                    <td>{formatNumber(row.perUnitSaleValue)}</td>
                    <td>{formatNumber(row.exFactoryValue)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer Section - Export Share */}
        <div className="footer-section">
          <div className="row align-items-center">
            <div className="col-md-6">
              <label className="export-share-label">
                13 Share(%) of products / by-products directly exported (Rs)
              </label>
            </div>
            <div className="col-md-6">
              <input
                type="text"
                className="export-share-input"
                placeholder="Enter export share percentage"
              />
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row mt-4">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button type="button" className="btn btn_orange mx-1">
              Print  
              <i className="fa fa-print ms-1"></i>
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Save
            </button>
            <button type="reset" className="btn btn_orange mx-1">
              Reset
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button type="button" className="btn btn_orange mx-1">
              Back 
              <i className="fa fa-angle-left ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockJ; 